import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'reflexbox';
import { Text } from 'rebass';

import config from 'frontend/config';

const ToggleBox = ({
  selected,
  warning,
  text,
  textSize,
  textAlign,
  children,
  disabled,
  onClick,
  ...props
}) => {
  let backgroundColor = 'transparent';
  let borderColor = '#555';
  let textColor = null;
  if (selected) {
    backgroundColor = '#222';
    textColor = config.colors.orange;
    if (warning) {
      borderColor = config.colors.red;
    } else {
      borderColor = config.colors.orange;
    }
  }

  if (disabled) {
    borderColor = 'transparent';
  }

  let content;
  if (children) {
    content = children;
  } else {
    content = (
      <Text
        bold={selected}
        color={textColor}
        size={textSize}
        align={textAlign}
      >
        {text}
      </Text>
    );
  }
  return (
    <Box
      {...props}
      style={{
        cursor: 'pointer',
        border: `1px solid ${borderColor}`,
        backgroundColor,
        padding: 6,
        position: 'relative',
        userSelect: 'none',
        filter: disabled ? 'opacity(0.3)' : '',
        ...props.style,
      }}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      {content}
    </Box>
  );
};

ToggleBox.propTypes = {
  selected: PropTypes.bool,
  warning: PropTypes.bool,
  text: PropTypes.string,
  textSize: PropTypes.number,
  textAlign: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

ToggleBox.defaultProps = {
  selected: false,
  warning: false,
  text: null,
  textSize: 16,
  textAlign: 'left',
  children: null,
  disabled: false,
  style: {},
  onClick: () => {},
};

export default ToggleBox;
